import _puzzle from './wasmBridge';

const levelsCache: Map<string, { name: string; id: number }[]> = new Map();
export default async function initialisePuzzleMetadata(levels: Map<string, { name: string; id: number }[]>) {
  const puzzleModules = import.meta.glob('./models/*.ts');

  for (const path in puzzleModules) {
    const puzzle = path.match(/\/([^\/]+)\.ts$/)[1];
    if (levels.has(puzzle)) {
      continue;
    }

    if (levelsCache.has(puzzle)) {
      levels.set(puzzle, levelsCache.get(puzzle));
    }

    levels.set(puzzle, []);
    levelsCache.set(puzzle, []);

    await _puzzle.initialise({
      name: puzzle,
      colourOverrides: new Map(),
      onPresetAdded: (name: string, id: number) => {
        if (name === 'Custom') {
          return;
        }

        levels.get(puzzle).push({ name, id });
        levelsCache.get(puzzle).push({ name, id });
      },
      onUndoRedoEnabled: () => {},
      onInitialise: (_state: string) => {},
      onMove: (_move: string) => {},
      onCompleted: () => {},
    });
  }
};
